var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkExternal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 80,
    viewBox: "0 0 79 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.2051 63.3115V25.2256C60.2051 23.3864 59.6354 21.889 58.4961 20.7334C57.3567 19.5778 55.8431 19 53.9551 19H15.8448C14.0869 19 12.6302 19.5737 11.4746 20.7212C10.319 21.8687 9.74118 23.2481 9.74118 24.8594C9.74118 26.4219 10.3312 27.7524 11.5113 28.8511C12.6913 29.9497 14.1276 30.499 15.8203 30.499H29.1748L41.5039 30.0107L34.7412 35.9434L2.00198 68.7559C0.667326 70.1068 0 71.5716 0 73.1504C0 74.7129 0.614426 76.1126 1.84328 77.3496C3.07208 78.5866 4.46775 79.2051 6.03028 79.2051C7.62535 79.2051 9.09831 78.5459 10.4492 77.2275L43.2373 44.4394L49.2188 37.6768L48.6573 49.9326V63.3848C48.6573 65.0775 49.2066 66.5138 50.3052 67.6938C51.4038 68.8739 52.7507 69.4639 54.3457 69.4639C55.9407 69.4639 57.3161 68.8698 58.4717 67.6816C59.6273 66.4935 60.2051 65.0368 60.2051 63.3115Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkExternal);
export default __webpack_public_path__ + "static/media/Link_external.f63148103ce185d49f335946496fd38f.svg";
export { ForwardRef as ReactComponent };